const CollapsibleTabs = {
  init() {
    $('.js-tabs-collapsible').each( (_, el) => this.setup($(el)) );
  },
  setup($tab_group) {
    const $nav = $('<nav class="c-tabs__nav" />');

    $tab_group.find('.js-tabs-title').each( (i, el) => {
      const $title = $(el);
      const title_text = $title.text();
      let tab_active = '';

      const $panel = this.getPanelForTitle($title);
      if ( $panel.length === 0 ) { return; }

      let panel_id = $panel.attr('id');
      if ( !panel_id ) {
        panel_id = title_text.replace(/\W+/g, '-');
        $panel.attr('id', panel_id);
      }
      // Activate the first panel
      if ( i === 0 ) {
        $panel.addClass('is-active');
        tab_active = 'is-active';
      }
      
      $nav.append(`<a href="#${panel_id}" class="c-tabs__nav-link js-tab-nav-link ${tab_active}">${title_text}</a>`);

    } );
    $tab_group.prepend($nav);

    // Nav link click - desktop
    $tab_group.on('click', '.js-tab-nav-link', event => this.navClick(event));
    $tab_group.on('click', '.js-tabs-title', event => this.titleClick(event));


    if(window.location.hash) {
      let hash = window.location.hash;
      if($('.leadership-bio'+hash).is(":hidden")){
        let panelFromUrl = $('.leadership-bio'+hash).parent().parent().attr('id');
        $('.c-tabs__nav').find(`a[href="#${panelFromUrl}"]`).trigger("click");
      }
    }
  },
  // On desktop
  navClick(event) {
    event.preventDefault();

    const $link = $(event.target);
    const $panel = this.getPanelForLink($link);
    if ( $panel.length === 0 ) { return; }

    // Change nav state
    $link.addClass('is-active')
      .siblings().removeClass('is-active')
    ;

    // Change panel state
    $panel.addClass('is-active')
      .siblings().removeClass('is-active')
    ;
  },
  // On mobile
  titleClick(event) {
    event.preventDefault();

    const $title = $(event.target);
    const $panel = this.getPanelForTitle($title);
    if ( $panel.length === 0 ) { return; }

    // Close other panels
    $panel
      .siblings('.is-active')
      .removeClass('is-active')
      .find('.js-tabs-content')
      .slideUp()
    ;

    if($panel.hasClass('is-active')){
      // Close this panel
      $panel.removeClass('is-active');
      $title.removeClass('is-active');
    }else{
      // Open this panel
      $panel
      .addClass('is-active')
      .find('.js-tabs-content')
      .slideDown();
    }
  },
  getPanelForLink($link) {
    let id = $link.attr('href');
    if ( id.substring(0, 1) === '#' ) {
      id = id.substring(1);
    }

    const $group = $link.closest('.js-tabs-collapsible');
    return $group.find(`#${id}`);
  },
  getPanelForTitle($title) {
    // Try to look by helper class first
    let $panel = $title.closest('.js-tabs-panel');

    if ( $panel.length === 0 ) {
      // Fall back to markup structure
      $panel = $title.closest('div');
    }

    return $($panel);
  },
};

$(CollapsibleTabs.init.bind(CollapsibleTabs));
